'use strict';

exports.__esModule = true;

var _ramda = /*#__PURE__*/require('ramda');

var _isFalsy = /*#__PURE__*/require('./isFalsy');

var _isFalsy2 = /*#__PURE__*/_interopRequireDefault(_isFalsy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an array with all falsy values removed.
 * The values false, null, 0, "", undefined, and NaN are falsy.
 *
 * @func compact
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/2.5.0|v2.5.0}
 * @category List
 * @sig Filterable f => f a -> f a
 * @param {Array} list The array to compact
 * @return {Array} Returns the new array of filtered values
 * @see {@link RA.isFalsy|isFalsy}
 * @example
 *
 * RA.compact([0, 1, false, 2, '', 3]); //=> [1, 2, 3]
 */
var compact = /*#__PURE__*/(0, _ramda.reject)(_isFalsy2.default);

exports.default = compact;


//////////////////
// WEBPACK FOOTER
// ./~/ramda-adjunct/lib/compact.js
// module id = 862
// module chunks = 168707334958949